import React from "react";
import Link from "next/link";
import Image from "next/image";
import { parseHtml, toWebp } from "@/utils/common";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

const socialIcons: Record<string, string> = {
  email: "/images/leadership/mail-dark.svg",
  linkedin: "/images/leadership/linkedin-dark.svg",
};

interface TechMeetProps {
  block?: any;
}

const TechMeet = ({ block }: TechMeetProps) => {
  const imageUrl = block?.image?.data?.attributes?.url;

  return (
    <section>
      <div className="leader-banner bg-background-dark xl:py-[100px] lg:py-[80px] py-[56px] relative z-0 overflow-hidden">
        {/* Content */}
        <div className="container">
          <div className="grid grid-cols-1 lg:[grid-template-columns:calc(60%-15px)_calc(40%-15px)] gap-[30px] z-1 items-center">
            {/* Left Content */}
            <div className="relative z-[2] lg:pr-[30px] xl:pr-[50px] pr-[0px]">
              {block?.title && (
                <p
                  className="lg:text-left text-center xl:text-[24px] xl:leading-[31.2px] text-[20px] leading-[26px] font-bold text-transparent mb-[20px]"
                  style={{
                    background:
                      "linear-gradient(10deg, #0086E6 3%, #8ABC00 62%)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                  }}
                >
                  {block.title}
                </p>
              )}

              {block?.subtitle && (
                <h2 className="text-white font-bold xl:text-[56px] xl:leading-[72.8px] lg:text-[48px] lg:leading-[62.4px] text-[32px] leading-[41.6px] mb-[8px] lg:text-left text-center">
                  {block.subtitle}
                </h2>
              )}

              <div className="mt-[24px] relative">
                <div className="flex flex-col gap-[24px] text-[#EDEDEE] font-regular xl:text-[20px] xl:leading-[28px] text-[18px] leading-[25.2px] font-regular mb-[24px] md:text-left text-center">
                  {parseHtml(block?.description)}
                </div>

                {block?.quaote && (
                  <div className="inline-flex items-center gap-4 py-[24px]">
                    <div className="w-[4px] h-[55px] bg-[#8ABC00] shrink-0 md:block hidden" />

                    <p className="text-white xl:text-[24px] xl:leading-[31.2px] text-[20px] leading-[26px] font-bold md:text-left text-center">
                      {block.quaote}
                    </p>
                  </div>
                )}

                {block?.social_links?.length > 0 && (
                  <div className="flex items-center gap-4 mt-[24px]">
                    {block.social_links.map((item: any, index: number) => (
                      <Link
                        href={item.href ?? "#"}
                        key={item.id ?? index}
                        className="w-[40px] h-[40px] border border-[#FFFFFF33] flex items-center justify-center cursor-pointer hover:border-[#8f8f8f] transition-all duration-500"
                      >
                        <Image
                          width={24}
                          height={24}
                          alt={item.label ?? "social"}
                          className="object-cover w-[20px] h-[20px]"
                          src={
                            socialIcons[item?.label?.toLowerCase()] ??
                            socialIcons.linkedin
                          }
                        />
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Right Image */}
            <div className="flex lg:justify-end justify-center relative ">
              <div className="relative">
                <div>
                  {imageUrl && (
                    <Image
                      src={toWebp(`${baseUrl}${imageUrl}`)}
                      alt={block?.name ?? "TRooTech leadership"}
                      width={390 * 2}
                      height={500 * 2}
                      quality={100}
                      className="object-contain sm:w-[390px] sm:h-[500px] w-full h-[340px] pointer-events-none"
                    />
                  )}
                </div>
              </div>
            </div>
            {/* End Right */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechMeet;
